import { normalizeUrlProtocol } from "../../utils/redirectUrlBuilder";

/**
 * Full-screen overlay shown when the checkout session TTL elapses.
 */
const SessionExpiredOverlay = ({
  onRestart,
  canRestart = true,
  returnUrl,
  merchantName,
}) => {
  let returnHref = null;
  if (returnUrl) {
    try {
      returnHref = new URL(normalizeUrlProtocol(returnUrl)).origin;
    } catch {
      returnHref = normalizeUrlProtocol(returnUrl);
    }
  }

  const returnLabel = merchantName?.trim()
    ? `Return to ${merchantName.trim()}`
    : "Return to store";

  return (
    <div style={styles.overlay} role="dialog" aria-modal="true">
      <div style={styles.card}>
        <div style={styles.iconWrap}>
          <svg
            width="28"
            height="28"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#b45309"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 7 12 12 15 14" />
          </svg>
        </div>
        <h1 style={styles.heading}>Checkout link expired</h1>
        <p style={styles.sub}>
          {canRestart
            ? "For your security, this checkout session has timed out. You can start a new one to continue."
            : "For your security, this checkout session has timed out. Please return to the merchant's website to start a new checkout."}
        </p>
        <div style={styles.actions}>
          {canRestart && (
            <button type="button" style={styles.buttonPrimary} onClick={onRestart}>
              Restart checkout
            </button>
          )}
          {returnHref && (
            <a
              href={returnHref}
              style={canRestart ? styles.buttonSecondary : styles.buttonPrimary}
            >
              {returnLabel}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    zIndex: 2000,
    backgroundColor: "rgba(15, 23, 42, 0.55)",
    backdropFilter: "blur(2px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', sans-serif",
  },
  card: {
    maxWidth: "400px",
    width: "100%",
    backgroundColor: "#ffffff",
    borderRadius: "16px",
    border: "1px solid #e2e8f0",
    boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
    padding: "36px 32px",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "12px",
  },
  iconWrap: {
    width: "56px",
    height: "56px",
    borderRadius: "50%",
    backgroundColor: "#fef3c7",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "4px",
  },
  heading: {
    fontSize: "22px",
    fontWeight: "600",
    color: "#0f172a",
    margin: 0,
    letterSpacing: "-0.3px",
  },
  sub: {
    fontSize: "14px",
    color: "#64748b",
    margin: 0,
    lineHeight: "1.6",
  },
  actions: {
    marginTop: "8px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  buttonPrimary: {
    width: "100%",
    padding: "11px 12px",
    backgroundColor: "#0f172a",
    color: "#ffffff",
    border: "none",
    borderRadius: "10px",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    fontFamily: "inherit",
  },
  buttonSecondary: {
    width: "100%",
    padding: "11px 12px",
    backgroundColor: "#ffffff",
    color: "#0f172a",
    border: "1px solid #cbd5e1",
    borderRadius: "10px",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    fontFamily: "inherit",
  },
};

export default SessionExpiredOverlay;
